import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main/Main';

export const QuickVideos = () => (
  <>
    <DocumentHead title='Quick Videos' />
    <PageTemplate main={<Main />} />
  </>
);
